import Vue from "vue";
import Vuelidate from "vuelidate";
import "./modules/common";
import "../Styles/templates/newsletterSignup.less";
import LazyLoad from "vanilla-lazyload/dist/lazyload";
import VueHelper from "./modules/vueHelper";
import NewsletterSignupForm from "#/NewsletterSignupForm.vue";

// Require critical styles if not in production,
// as the template will only inline them in production.
/* eslint-disable global-require */
if ( process.env.NODE_ENV !== "production" ) {
  require( "../Styles/critical/newsletterSignup.less" );
}
/* eslint-enable global-require */

Object.values( VueHelper.CommonPlugins() ).forEach( x => {
  Vue.use( x );
} );

Vue.use( Vuelidate );

Object.values( VueHelper.CommonComponents() ).forEach( x => {
  Vue.component( x.name, x );
} );

Vue.component( "NewsletterSignupForm", NewsletterSignupForm );

const csrfToken = document.querySelector( "meta[name=\"csrf-token\"]" ).getAttribute( "content" );
Vue.prototype.$csrfToken = csrfToken;

new Vue( {
  el: "#app",
  store: VueHelper.Store(),
  data () {
    return {
      dimmed: false
    };
  }
} );

// Enable image lazyloading
new LazyLoad( {
  elements_selector: "img, .lazy"
} );
